var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from "react";
import { Link } from "react-router-dom";
import { parseISO, format } from "date-fns";
import { IconButton, Menu, MenuItem, TableCell, TableRow, } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { MoreVert } from "@material-ui/icons";
import { green, red } from "@material-ui/core/colors";
import { useConfirmationDialog } from "frontend/src/ui/dialog";
import { useCopyPlaylist, useDeletePlaylist, usePublishPlaylist, } from "frontend/src/domain/playlists";
import { paths } from "frontend/src/pages/paths/index";
var useStyles = makeStyles({
    remove: {
        color: red[700],
    },
    published: {
        color: function (_a) {
            var isPublished = _a.isPublished;
            return (isPublished ? green[500] : red[700]);
        },
    },
});
export var PlaylistsTableRow = function (_a) {
    var id = _a.id, title = _a.title, type = _a.type, createdAt = _a.createdAt, updatedAt = _a.updatedAt, duration = _a.duration, trackCount = _a.trackCount, isPublished = _a.isPublished;
    var classes = useStyles({ isPublished: isPublished });
    var _b = __read(React.useState(null), 2), anchor = _b[0], setAnchor = _b[1];
    var handleClick = function (event) {
        setAnchor(event.currentTarget);
    };
    var close = function () { return setAnchor(null); };
    var remove = useDeletePlaylist();
    var copy = useCopyPlaylist();
    var publish = usePublishPlaylist().mutate;
    var _c = useConfirmationDialog({
        message: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u043B\u0435\u0439\u043B\u0438\u0441\u0442 \"".concat(title, "\"?"),
        onConfirm: function () { return remove.do(id); },
        open: false,
    }), open = _c.open, Dialog = _c.Dialog;
    return (React.createElement(React.Fragment, null,
        React.createElement(TableRow, null,
            React.createElement(TableCell, null, title),
            React.createElement(TableCell, null, type === "private" ? "Клиентский" : "Публичный"),
            React.createElement(TableCell, null, duration),
            React.createElement(TableCell, null, trackCount),
            React.createElement(TableCell, { className: classes.published }, isPublished ? "Да" : "Нет"),
            React.createElement(TableCell, null, format(parseISO(createdAt), "dd-MM-yyyy")),
            React.createElement(TableCell, null, format(parseISO(updatedAt), "dd-MM-yyyy")),
            React.createElement(TableCell, null,
                React.createElement(IconButton, { size: "small", onClick: handleClick },
                    React.createElement(MoreVert, null)),
                React.createElement(Menu, { anchorEl: anchor, keepMounted: true, open: Boolean(anchor), onClose: close },
                    React.createElement(MenuItem, { onClick: function () {
                            publish({ id: id, publish: !isPublished });
                            close();
                        } }, isPublished ? "Убрать из публикации" : "Опубликовать"),
                    React.createElement(MenuItem, { component: Link, to: paths.admin.playlists.edit(id) }, "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C"),
                    React.createElement(MenuItem, { onClick: function () {
                            copy.do(id);
                            close();
                        } }, "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C"),
                    React.createElement(MenuItem, { className: classes.remove, onClick: function () {
                            open();
                            close();
                        } }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C")))),
        React.createElement(Dialog, null)));
};
